import React from "react";
import { STATUS_STYLES } from "@/lib/avocado";

export function StatusBadge({ status, size = "sm" }) {
  const s = STATUS_STYLES[status] || STATUS_STYLES["Referred"];
  const px = size === "lg" ? "px-3 py-1.5 text-xs" : "px-2.5 py-1 text-[10.5px]";
  return (
    <span
      data-testid={`status-badge-${status?.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center rounded-full font-bold uppercase tracking-wider ${px}`}
      style={{ backgroundColor: s.bg, color: s.text, border: `1.5px solid ${s.border}` }}
    >
      {status}
    </span>
  );
}

const STAGES = ["Referred", "Confirmed Client", "Sale Completed"];

export function StatusPipeline({ current }) {
  const currentIdx = STAGES.indexOf(current);
  return (
    <div className="flex items-center w-full overflow-x-auto pb-2" data-testid="status-pipeline">
      {STAGES.map((s, i) => {
        const done = i < currentIdx;
        const active = i === currentIdx;
        const color = active ? "#EC008C" : done ? "#B4D338" : "#E4DBCB";
        return (
          <React.Fragment key={s}>
            <div className="flex flex-col items-center min-w-[70px]">
              <div
                className={`w-3.5 h-3.5 rounded-full ${active ? "pulse-dot" : ""}`}
                style={{
                  background: color,
                  boxShadow: active ? "0 0 0 5px rgba(236,0,140,0.15)" : "none",
                  border: done ? "2px solid #7A9024" : active ? "2px solid #C4007A" : "2px solid transparent",
                }}
              />
              <div
                className="text-[10px] mt-2 text-center font-bold tracking-wide uppercase"
                style={{ color: done || active ? "#171717" : "#B9B0A2", maxWidth: 72, lineHeight: 1.1 }}
              >
                {s}
              </div>
            </div>
            {i < STAGES.length - 1 && (
              <div
                className="flex-1 h-[3px] mx-1 rounded-full"
                style={{ background: i < currentIdx ? "#B4D338" : "#EFE7D7", minWidth: 12 }}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
